import {AppBar, Toolbar,} from '@mui/material';

import useStyles from './useStyles'
import {HeaderMain} from '../../Components/main/HeaderMain';
import {useCloseBurgerMenu} from "../../Hooks/useCloseBurgerMenu/useCloseBurgerMenu";

const Panel = () => {

    useCloseBurgerMenu()

    const classes = useStyles()
    return (
        <AppBar className={classes.appBar} position="fixed">
            <Toolbar className={classes.toolBar}>
                <HeaderMain activSuperCat="management"/>
            </Toolbar>
        </AppBar>
    );
}

export default Panel;
